import strategyPaperInitState from "../InitStates/strategy-papyer-init-state";
import decisionSheetInitState from "../InitStates/decision-sheet-init-state";
import AnnualReportInitStatement from "../InitStates/annual-report-init-state";

const initState = {
	StrategyPaper: { ...strategyPaperInitState },
	DecisionSheet: { ...decisionSheetInitState },
	AnnualReport: { ...AnnualReportInitStatement }
}

// Deep-merge the incoming form data over the default init state.
// Saved forms from older sessions may miss whole sections or periods
// (e.g. cashFlow added later) - merging keeps those fields at their
// defaults instead of leaving them undefined and crashing the views.
const mergeForm = (defaults, value) => {
	if (Array.isArray(defaults) || typeof defaults !== "object" || defaults === null) {
		return (value !== undefined) ? value : defaults;
	}

	const merged = { ...defaults };
	if (typeof value === "object" && value !== null) {
		Object.keys(value).forEach((key) => {
			merged[key] = mergeForm(defaults[key], value[key]);
		});
	}

	return merged;
}

const formInitStates = {
	StrategyPaper: strategyPaperInitState,
	DecisionSheet: decisionSheetInitState,
	AnnualReport: AnnualReportInitStatement
}

const reducer = (state = initState, action) => {
	if (action.type === "UPDATE_FORM") {
		return {
			...state,
			[action.form]: mergeForm(formInitStates[action.form] || {}, action.value)
		}
	}else if (action.type === "StrategyPaper") {
		if (action.option !== undefined) {
			state[action.type][action.section][action.field][action.option] = action.value
		}else{
			state[action.type][action.section][action.field] = action.value
		}

		return {
			...state,
			StrategyPaper: {
				...state.StrategyPaper
			}
		}
	}else if (action.type === "DecisionSheet") {
		state[action.type][action.section][action.field][action.option] = action.value;

		return {
			...state,
			DecisionSheet: {
				...state.DecisionSheet
			}
		}
	}else if (action.type === "AnnualReport") {
		if (action.option !== undefined) {
			if (state[action.type][action.section] === undefined) {
				state[action.type][action.section] = {}
			}
			if (state[action.type][action.section][action.option] === undefined) {
				state[action.type][action.section][action.option] = {}
			}
			state[action.type][action.section][action.option][action.field] = action.value;
		}else{
			state[action.type][action.section][action.field] = action.value
		}

		return {
			...state,
			AnnualReport: {
				...state.AnnualReport
			}
		}
	}

	return state;
}

export default reducer;
